import React from 'react';
import * as moment from 'moment';
import Check from 'mdi-react/CheckIcon';
import { withRouter } from 'react-router-dom';
import { Typography } from '@material-ui/core';

import Box from 'components/Box';
import { PrimaryButton } from 'components/Buttons/PrimaryButton';
import { OutlineButton } from 'components/Buttons/OutlineButton';
import Row from 'components/Row';
import Col from 'components/Col';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CalendarTodaySharpIcon from '@material-ui/icons/CalendarTodaySharp';
import AutorenewSharpIcon from '@material-ui/icons/AutorenewSharp';
import color from 'config/color';

function ExamCard({ history, exam, onStart }) {
  const quiz = exam.quiz;

  function getButton() {
    if (quiz && quiz.completed)
      return (
        <PrimaryButton disabled>
          <Check /> Completed
        </PrimaryButton>
      );
    else if (exam.status === 'scheduled')
      return <OutlineButton disabled>Not Started</OutlineButton>;
    else if (quiz)
      return (
        <PrimaryButton
          // disabled={exam.status !== "started"}
          onClick={() => onStart(exam)}
        >
          Continue
        </PrimaryButton>
      );
    else
      return (
        <PrimaryButton
          // disabled={exam.status !== "started"}
          onClick={() => onStart(exam)}
        >
          Give Exam
        </PrimaryButton>
      );
  }

  return (
    <Box
      boxShadow={10}
      margin="20px 0"
      padding="0"
      borderRadius="10px"
      style={{
        height: '100%',
        margin: '20px 0',
        marginRight: '40px'
      }}
      key={exam.examKey}
    >
      <Row marginbottom="0px">
        <Col
          justify={'center'}
          display={'none'}
          style={{ background: color.medilinkColor }}
        >
          <Typography style={{ color: color.white }} variant="h3">
            <Typography style={{ color: color.white }} variant="h6">
              {moment(exam.startTime).format('L')}
            </Typography>
            {moment(exam.startTime).format('MMM DD')}
          </Typography>
        </Col>
        <Col>
          <Typography variant="h5">{exam.name}</Typography>
          <Row>
            <AccessTimeIcon /> Time: {moment(exam.startTime).format('hh:mm A')}
          </Row>
          <Row>
            <AutorenewSharpIcon />
            Ended At: {moment(exam.endTime).format('hh:mm A')}
          </Row>
          <Row>
            <Row>
              <CalendarTodaySharpIcon />
              Result At: {moment(exam.resultDate).format('ddd hh:mm A, MMM DD')}
            </Row>
          </Row>
          <div style={{ marginBottom: 15 }} />
          {getButton()}
        </Col>
      </Row>
    </Box>
  );
}

export default withRouter(ExamCard);
